module.exports = __webpack_public_path__ + "static/media/paper-plane.47be7439.svg";